export default __webpack_public_path__ + "static/media/securityman.b644c440.jpg";